import { render, staticRenderFns } from "./openTicketAgain.vue?vue&type=template&id=2e362022"
import script from "./openTicketAgain.vue?vue&type=script&lang=js"
export * from "./openTicketAgain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports